export enum Permission {
  EnterpriseStatusPageView = 'enterprise_status_page.view',
  CaperBillingView = 'caper_billing.view',
}
